import React from "react";
import { useI18n } from "@/i18n";

/**
 * Opens WhatsApp with a pre-filled message + url.
 * Uses wa.me universal link — works on mobile (app) and desktop (web).
 */
export default function WhatsAppShareButton({
  text,
  url,
  className = "",
  label,
  testId = "whatsapp-share-button",
}) {
  const { isRTL } = useI18n();

  const shareUrl =
    url || (typeof window !== "undefined" ? window.location.href : "");

  const handleClick = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    const message = `${text ? text + "\n\n" : ""}${shareUrl}`;
    const waHref = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(waHref, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testId}
      aria-label={label || (isRTL ? "مشاركة عبر واتساب" : "Share on WhatsApp")}
      className={`inline-flex items-center gap-2 rounded-full text-xs font-medium px-3 py-2 bg-[#25D366] text-white hover:bg-[#1ebe57] transition-colors ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.02 0C5.42 0 .06 5.36.06 11.96c0 2.11.55 4.17 1.6 5.99L0 24l6.21-1.63a11.94 11.94 0 0 0 5.81 1.48h.01c6.6 0 11.96-5.36 11.96-11.96 0-3.19-1.25-6.19-3.47-8.41ZM12.03 21.8h-.01a9.84 9.84 0 0 1-5.02-1.38l-.36-.21-3.69.97.98-3.6-.23-.37a9.85 9.85 0 0 1-1.51-5.25c0-5.45 4.43-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.9 6.99c0 5.45-4.44 9.83-9.94 9.83Zm5.41-7.36c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.93 1.17-.17.2-.34.22-.64.07-.3-.15-1.25-.46-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.49.1-.2.05-.37-.02-.52-.07-.15-.66-1.59-.91-2.18-.24-.57-.48-.49-.66-.5-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.09 3.19 5.06 4.47.71.31 1.26.49 1.69.62.71.22 1.35.19 1.86.12.57-.08 1.76-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.13-.27-.2-.57-.34Z" />
      </svg>
      {label && <span>{label}</span>}
    </button>
  );
}
